import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M677.647059,872.097882 L677.647059,1047.94729 C677.647059,1155.12847 764.837647,1242.31906 872.131765,1242.31906 L934.927059,1242.31906 C1042.22118,1242.31906 1129.41176,1155.12847 1129.41176,1047.94729 L1129.41176,872.097882 C1129.41176,764.916706 1042.22118,677.613176 934.927059,677.613176 L872.131765,677.613176 C764.837647,677.613176 677.647059,764.916706 677.647059,872.097882 M1411.76471,677.647059 L1171.08706,677.647059 C1214.90824,730.842353 1242.35294,797.929412 1242.35294,872.131765 L1242.35294,1047.86824 C1242.35294,1217.39294 1104.45176,1355.29412 934.927059,1355.29412 L872.131765,1355.29412 C702.607059,1355.29412 564.705882,1217.39294 564.705882,1047.86824 L564.705882,872.131765 C564.705882,702.607059 702.607059,564.705882 872.131765,564.705882 L1411.76471,564.705882 L1411.76471,677.647059 Z M960,0 C430.644706,0 -2.5243549e-29,430.644706 -2.5243549e-29,960 C-2.5243549e-29,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,0 960,0 L960,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizStatsDeviationSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizStatsDeviationSolid, _Component);

  var _super = _createSuper(IconQuizStatsDeviationSolid);

  function IconQuizStatsDeviationSolid() {
    _classCallCheck(this, IconQuizStatsDeviationSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizStatsDeviationSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuizStatsDeviation",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconQuizStatsDeviationSolid.displayName = "IconQuizStatsDeviationSolid";
  return IconQuizStatsDeviationSolid;
}(Component);

IconQuizStatsDeviationSolid.glyphName = 'quiz-stats-deviation';
IconQuizStatsDeviationSolid.variant = 'Solid';
IconQuizStatsDeviationSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizStatsDeviationSolid;
export { IconQuizStatsDeviationSolid };